// This icon file is generated automatically.
var PtoCirCopyrightCircleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 32 32", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M16 2a14 14 0 100 28 14 14 0 000-28zm0 25.63a11.63 11.63 0 110-23.26 11.63 11.63 0 010 23.25zm.18-16.65c1.65 0 2.78 1.05 2.9 2.6.01.14.12.24.25.24h1.77c.08 0 .15-.07.15-.15 0-2.71-2.14-4.6-5.08-4.6-3.44 0-5.42 2.31-5.42 6.14v1.64c0 3.8 1.98 6.09 5.42 6.09 2.93 0 5.08-1.84 5.08-4.42a.15.15 0 00-.15-.15h-1.77c-.13 0-.24.1-.25.23-.13 1.44-1.25 2.43-2.9 2.43-2.05 0-3.2-1.5-3.2-4.17V15.2c0-2.72 1.16-4.23 3.2-4.23z", "fill-rule": "nonzero" } }] }, "name": "pto-cir-copyright-circle", "theme": "outlined" };
export default PtoCirCopyrightCircleOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PtoCirCopyrightCircleOutlined.js
// module id = 3893
// module chunks = 0